"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require(".");

var Veterinarian =
/** @class */
function () {
  function Veterinarian() {
    this.id = null;
    this.firstName = null;
    this.lastName = null;
    this.title = null;
    this.email = null;
    this.isActive = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.practiceId = null;
    this.practice = null;
    this.tests = null;
  }

  Veterinarian.thaw = function (veterinarianObj) {
    var _a, _b;

    if (veterinarianObj == null) return null;
    var veterinarian = new Veterinarian();

    if (veterinarianObj.id != null) {
      veterinarian.setId(veterinarianObj.id);
    }

    if (veterinarianObj.firstName != null) {
      veterinarian.setFirstName(veterinarianObj.firstName);
    }

    if (veterinarianObj.lastName != null) {
      veterinarian.setLastName(veterinarianObj.lastName);
    }

    if (veterinarianObj.title != null) {
      veterinarian.setTitle(veterinarianObj.title);
    }

    if (veterinarianObj.email != null) {
      veterinarian.setEmail(veterinarianObj.email);
    }

    if (veterinarianObj.isActive != null) {
      veterinarian.setIsActive(veterinarianObj.isActive == null ? null : veterinarianObj.isActive ? true : false);
    }

    if (veterinarianObj.createdAt != null) {
      veterinarian.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(veterinarianObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (veterinarianObj.updatedAt != null) {
      veterinarian.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(veterinarianObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (veterinarianObj.practiceId != null) {
      veterinarian.setPracticeId(veterinarianObj.practiceId);
    }

    if (veterinarianObj.practice != null) {
      veterinarian.setPractice(_.Practice.thaw(veterinarianObj.practice));
    }

    if (veterinarianObj.tests != null) {
      veterinarian.setTests(_.Test.thawList(veterinarianObj.tests));
    }

    return veterinarian;
  };

  Veterinarian.thawList = function (veterinarianObjList) {
    if (veterinarianObjList == null) {
      return [];
    }

    var veterinarians = [];

    for (var i = 0; i < veterinarianObjList.length; i++) {
      veterinarians.push(Veterinarian.thaw(veterinarianObjList[i]));
    }

    return veterinarians;
  };

  Veterinarian.freeze = function (veterinarian) {
    var _a, _b, _c, _d;

    if (veterinarian == null) {
      return null;
    }

    var veterinarianObj = {};

    if (veterinarian.getId() != null) {
      veterinarianObj.id = veterinarian.getId();
    }

    if (veterinarian.getFirstName() != null) {
      veterinarianObj.firstName = veterinarian.getFirstName();
    }

    if (veterinarian.getLastName() != null) {
      veterinarianObj.lastName = veterinarian.getLastName();
    }

    if (veterinarian.getTitle() != null) {
      veterinarianObj.title = veterinarian.getTitle();
    }

    if (veterinarian.getEmail() != null) {
      veterinarianObj.email = veterinarian.getEmail();
    }

    if (veterinarian.getIsActive() != null) {
      veterinarianObj.isActive = veterinarian.getIsActive() == null ? null : veterinarian.getIsActive() ? 1 : 0;
    }

    if (veterinarian.getCreatedAt() != null) {
      veterinarianObj.createdAt = (_b = (_a = veterinarian.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (veterinarian.getUpdatedAt() != null) {
      veterinarianObj.updatedAt = (_d = (_c = veterinarian.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (veterinarian.getPracticeId() != null) {
      veterinarianObj.practiceId = veterinarian.getPracticeId();
    }

    if (veterinarian.getPractice() != null) {
      veterinarianObj.practice = _.Practice.freeze(veterinarian.getPractice());
    }

    if (veterinarian.getTests() != null) {
      veterinarianObj.tests = _.Test.freezeList(veterinarian.getTests());
    }

    return veterinarianObj;
  };

  Veterinarian.freezeList = function (veterinarians) {
    if (veterinarians == null) {
      return [];
    }

    var veterinarianObjList = [];

    for (var i = 0; i < veterinarians.length; i++) {
      veterinarianObjList.push(Veterinarian.freeze(veterinarians[i]));
    }

    return veterinarianObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  Veterinarian.prototype.setId = function (id) {
    this.id = id;
  };

  Veterinarian.prototype.setFirstName = function (firstName) {
    this.firstName = firstName;
  };

  Veterinarian.prototype.setLastName = function (lastName) {
    this.lastName = lastName;
  };

  Veterinarian.prototype.setTitle = function (title) {
    this.title = title;
  };

  Veterinarian.prototype.setEmail = function (email) {
    this.email = email;
  };

  Veterinarian.prototype.setIsActive = function (isActive) {
    this.isActive = isActive;
  };

  Veterinarian.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  Veterinarian.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  Veterinarian.prototype.setPracticeId = function (practiceId) {
    this.practiceId = practiceId;
  };

  Veterinarian.prototype.setPractice = function (practice) {
    this.practice = practice;
  };

  Veterinarian.prototype.setTests = function (tests) {
    this.tests = tests;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  Veterinarian.prototype.getId = function () {
    return this.id;
  };

  Veterinarian.prototype.getFirstName = function () {
    return this.firstName;
  };

  Veterinarian.prototype.getLastName = function () {
    return this.lastName;
  };

  Veterinarian.prototype.getTitle = function () {
    return this.title;
  };

  Veterinarian.prototype.getEmail = function () {
    return this.email;
  };

  Veterinarian.prototype.getIsActive = function () {
    return this.isActive;
  };

  Veterinarian.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  Veterinarian.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  Veterinarian.prototype.getPracticeId = function () {
    return this.practiceId;
  };

  Veterinarian.prototype.getPractice = function () {
    return this.practice;
  };

  Veterinarian.prototype.getTests = function () {
    return this.tests;
  };
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  Veterinarian.prototype.getFullName = function () {
    return this.firstName != null && this.lastName != null ? this.firstName + ' ' + this.lastName : null;
  };

  return Veterinarian;
}();

var _default = Veterinarian;
exports.default = _default;